import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail_other.svg';
const MailOther = () => React.createElement(IconSvg, null);
export default MailOther;
